import React from "react";
import {
  ApiCard,
  ApiCardHeader,
  ApiCardTitle,
  ApiCardPath,
  MethodBadge,
  EndpointPath,
  StatusCodeBadge,
} from "../styles/StyledComponents";

/**
 * Renders an API endpoint card
 * @param {Object} props - Component props
 * @param {Object} props.endpoint - The endpoint object
 * @param {Function} props.onSelect - Function to call when endpoint is selected
 * @param {Object} props.result - The result of the API call (if any)
 * @returns {JSX.Element}
 */
const EndpointCard = ({ endpoint, onSelect, result, showCategory = false }) => {
  const { method, name, path, category } = endpoint;

  const handleClick = () => {
    if (typeof onSelect === "function") {
      onSelect(endpoint);
    }
  };

  return (
    <ApiCard onClick={handleClick} style={{ cursor: onSelect ? "pointer" : "default" }}>
      <ApiCardHeader>
        <ApiCardTitle>
          <MethodBadge method={method}>{method}</MethodBadge>
          <span>{name}</span>
          {showCategory && <span className="text-muted ms-2 small">({category})</span>}
        </ApiCardTitle>
        <ApiCardPath>
          <EndpointPath>{path}</EndpointPath>
          {result && <StatusCodeBadge statusCode={result.statusCode}>{result.statusCode}</StatusCodeBadge>}
        </ApiCardPath>
      </ApiCardHeader>
    </ApiCard>
  );
};

export default EndpointCard;
